import axios from "axios";
import { getAccessToken, logout } from "./authService";
import { API_BASE_URL } from "../config";
// authService — утилита для работы с токенами (может хранить в памяти или cookie)

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// 🔹 обработка ошибок
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // A 401 on a request carrying X-Tab-Access-Token means that one tab
    // token is missing/expired in Redis - it is NOT a session/JWT failure,
    // so it must not log the user out of the whole app.
    const hasTabAccessToken = Boolean(
      error.config?.headers?.["X-Tab-Access-Token"],
    );

    if (error.response?.status === 401 && !hasTabAccessToken) {
      logout();
      // Уведомляем AuthProvider для синхронизации состояния и редиректа на /login
      window.dispatchEvent(new Event("auth:logout"));
    }

    return Promise.reject(error);
  },
);

export default api;
